export default "<router-outlet></router-outlet>\n\n<ngx-ui-loader ></ngx-ui-loader>\n"